var _rect, _rect2, _rect3, _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKoduuLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 976,
    height: 152,
    viewBox: "0 0 976 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 44,
    height: 150,
    rx: 22,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 78.4418,
    width: 44,
    height: 110.292,
    rx: 22,
    transform: "rotate(-42 53 78.4418)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 15,
    width: 44,
    height: 44,
    rx: 22,
    transform: "rotate(-30 86 15)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 76,
    r: 75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412 22C412 9.84974 421.85 0 434 0H486.5C528.197 0 562 33.8025 562 75.5V75.5C562 117.197 528.197 151 486.5 151H434C421.85 151 412 141.15 412 129V129C412 116.85 421.85 107 434 107H486.5C503.897 107 518 92.897 518 75.5V75.5C518 58.103 503.897 44 486.5 44H434C421.85 44 412 34.1503 412 22V22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M747 0.999999C759.15 1 769 10.8497 769 23L769 75.5C769 117.197 735.197 151 693.5 151V151C651.802 151 618 117.197 618 75.5L618 23C618 10.8497 627.85 0.999994 640 0.999994V0.999994C652.15 0.999995 662 10.8497 662 23L662 75.5C662 92.897 676.103 107 693.5 107V107C710.897 107 725 92.897 725 75.5L725 23C725 10.8497 734.85 0.999999 747 0.999999V0.999999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M954 0.999999C966.15 1 976 10.8497 976 23L976 75.5C976 117.197 942.197 151 900.5 151V151C858.802 151 825 117.197 825 75.5L825 23C825 10.8497 834.85 0.999994 847 0.999994V0.999994C859.15 0.999995 869 10.8497 869 23L869 75.5C869 92.897 883.103 107 900.5 107V107C917.897 107 932 92.897 932 75.5L932 23C932 10.8497 941.85 0.999999 954 0.999999V0.999999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoduuLogoWhite);
export default __webpack_public_path__ + "static/media/Koduu_logo_white.275bc51fd1a616553b48eb7e6aa63e72.svg";
export { ForwardRef as ReactComponent };